export default __webpack_public_path__ + "static/media/trolleybus.cb2a89f4.png";